import { createResource } from "~/lib/resourceFactory";
import { getVendor, listVendors } from "./vendor.api";

type VendorsPage = Awaited<ReturnType<typeof listVendors>>;
type VendorDetail = Awaited<ReturnType<typeof getVendor>>;

export type VendorsParams = {
  businessId: string;
  search?: string;
  offset?: number;
  limit: number;
  ids?: string[];
};

export type VendorDetailParams = { businessId: string; id: string };

export const VendorsResource = createResource<VendorsPage, VendorsParams>({
  key: (p) =>
    [
      "vendor",
      p.businessId,
      p.limit,
      p.search ?? "",
      p.offset ?? 0,
      p.ids === undefined ? "*" : p.ids.join(","),
    ] as const,
  fetcher: (p) =>
    listVendors({
      data: {
        businessId: p.businessId,
        search: p.search,
        offset: p.offset,
        limit: p.limit,
        ids: p.ids,
      },
    }),
});

export const VendorDetailResource = createResource<
  VendorDetail,
  VendorDetailParams
>({
  key: ({ businessId, id }) => ["vendor", businessId, id] as const,
  fetcher: ({ businessId, id }) => getVendor({ data: { businessId, id } }),
});
